module.exports = __webpack_public_path__ + "static/img/gcgl_p2.2aae4cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/gcgl_p2.png
// module id = 3AnM
// module chunks = 19